export default __webpack_public_path__ + "static/media/bbbbb.d1f5506a.jpg";